import { LANGUAGES, ResourceLoader, Resources } from '@grafana/i18n';

const resources = LANGUAGES.reduce<Record<string, () => Promise<{ default: Resources }>>>((acc, lang) => {
  acc[lang.code] = async () => await import(`../locales/${lang.code}/grafana-scenes.json`);
  return acc;
}, {});

/**
 * Loads the translation resources for the given language and returns them.
 */
export const loadResources: ResourceLoader = async (resolvedLanguage: string) => {
  const translation = await resources[resolvedLanguage]();
  return translation.default;
};
